import {
  faX,
} from "@fortawesome/free-solid-svg-icons";
import {
  ContainerButton2, Form, Input, TextTitle, Title
} from '../../../../../styles/global';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormHandles } from "@unform/core";
import { useCallback, useEffect, useRef, useState } from "react";
import Panel from "../../../../../components/Panel";
import { Link, useParams } from "react-router-dom";
import { Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { SaveWithProgress } from "../../../../../components/SaveCircularIntegration";
import Radio from "../../../../../components/InputRadio";
import useFerias from "../../../../../actions/cruds/Rh/useFerias";

const RhFeriasEdit: React.FC = () => {
  const { feriasId } = useParams();
  const { ferias, getFerias, updateFerias } = useFerias();

  const [termino, setTermino] = useState<String>('');
  const [quantidadeDias, setQuantidadeDias] = useState<number>(0);
  const [salvando, setSalvando] = useState<boolean>(false);

  useEffect(() => {
    getFerias(feriasId);
  }, []);

  useEffect(() => {
    if (ferias?.id) {
      formRef.current?.setFieldValue("dataAdmissao", ferias.user?.data_admissao);
      formRef.current?.setFieldValue("periodo_aquisitivo_de", ferias.periodo_aquisitivo_de);
      formRef.current?.setFieldValue("periodo_aquisitivo_ate", ferias.periodo_aquisitivo_ate);
      formRef.current?.setFieldValue("periodo_gozo_de", ferias.periodo_gozo_de);
      formRef.current?.setFieldValue("periodo_gozo_ate", ferias.periodo_gozo_ate);
      formRef.current?.setFieldValue("inicio", ferias.inicio);
      formRef.current?.setFieldValue("termino", ferias.termino);

      if (ferias?.user?.employee_type?.key == 'empregado') {
        setQuantidadeDias(30);
        formRef.current?.setFieldValue("adiantamento", ferias?.adiantamento ? "true" : "false");
      } else if (ferias?.user?.employee_type?.key == 'estagiario' || ferias?.user?.employee_type?.key == 'jovem_aprendiz') {
        setQuantidadeDias(15);
      }
    }

  }, [ferias])

  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async (data: object) => {
      try {
        setSalvando(true);

        console.log("data", data);
        await updateFerias(feriasId, data);

      } catch (err) {

      } finally {
        setSalvando(false);
      }
    },
    [],
  );

  const optionsBoolean = [
    { id: "true", value: "true", label: "Sim" },
    { id: "false", value: "false", label: "Não" },
  ];

  const handlerChangeDataInicio = (dataInicio: string) => {
    let date = new Date(dataInicio.target.value);
    date.setDate(date.getDate() + quantidadeDias);
    date.setUTCHours(0, 0, 0, 0);
    const formattedDate = date.toISOString().split('T')[0];

    setTermino(formattedDate)
  };

  return (
    <Container>
      <Form id="formFerias" ref={formRef} onSubmit={handleSubmit}>
        <Title color='#333'>
          <span>Edição de Férias do empregado</span>
        </Title>

        <Panel titulo="Exercício">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Data de Admissão:</TextTitle>
              <Input name="dataAdmissao" type="date" disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Número de dias:</TextTitle>
              <Input type="text" name="quantidade_dias" value={quantidadeDias} disabled />
            </Grid>
            <Grid xs={6} lg={3}>
              <TextTitle>Período aquisitivo de:</TextTitle>
              <Input name="periodo_aquisitivo_de" type="date" required />
            </Grid>
            <Grid xs={6} lg={3}>
              <TextTitle>até:</TextTitle>
              <Input name="periodo_aquisitivo_ate" type="date" required />
            </Grid>
            <Grid xs={6} lg={3}>
              <TextTitle>Período para gozo de:</TextTitle>
              <Input type="date" name="periodo_gozo_de" required />
            </Grid>
            <Grid xs={6} lg={3}>
              <TextTitle>até:</TextTitle>
              <Input type="date" name="periodo_gozo_ate" required />
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Programação de Férias">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Início:</TextTitle>
              <Input name="inicio" type="date" onChange={handlerChangeDataInicio} required />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Término:</TextTitle>
              <Input name="termino" type="date" value={termino} disabled />
            </Grid>
            {ferias?.user?.employee_type?.key == 'empregado' && (
              <Grid xs={6}>
                <TextTitle>Adiantamento do 13º?</TextTitle>
                <Radio name="adiantamento" options={optionsBoolean} required />
              </Grid>
            )}
          </Grid>
        </Panel>
      </Form>

      <ContainerButton2>
        <Link to={`/rh/empregados/ferias/${ferias?.user?.id}`}>
          <button className="button_return">
            <FontAwesomeIcon icon={faX} size="1x" /> Cancelar
          </button>
        </Link>
        <SaveWithProgress disabled={salvando} form={"formFerias"}></SaveWithProgress>
      </ContainerButton2>
    </Container>
  );
};

export default RhFeriasEdit;